import MobileDetect from 'mobile-detect';

(function (window) {
  const md = new MobileDetect(navigator.userAgent);
  window.mobileDetect = md;
  window.mobileDetect.isIE = window.mobileDetect.ua.indexOf('Trident') > -1;
  window.mobileDetect.isEdge = window.mobileDetect.ua.indexOf('Edge') > -1;
})(window);
